import React from "react";
import styled from "styled-components";

export default styled.div`
    background: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 682px;
    min-height: auto;
    text-align: center;
    padding: 45px 62px 62px;
    box-sizing: border-box;
    display: none;
    z-index: 20;
    box-shadow: 5px 5px 25px #00000054;
    
    input {
        width: 100%;
        
        }
    
    form {
        text-align: left;
    }
    
    .rdtOpen .rdtPicker {
        top: -170%;
        left: 50%;
        transform: translate(-50%);
        border: 1px solid gray;
        z-index: 99999999999999999 !important;
    }
    
    .rte {
        min-height: 300px;
        width: 93%;
        margin: 0 auto;
    }
    
    hr {
        border: none;
        border-top: 1px solid lightgrey;
        margin-bottom: 15px;
        clear: both;
    }
    
    .rte span {
        font-weight: unset;
    }
    
    ${(props) => (props.open ? {
    'display': 'block',
} : '')}
`;